import type { ComponentProps } from "react";
import { LuMonitorPlay } from "react-icons/lu";

import { EDITOR_MEDIA_TAB } from "@/components/app/editor-v3/constants";
import { Button } from "@/components/ui/button";

import { useEditorContext } from "../editor-context";

export const EditorActionEmbed = (props: ComponentProps<typeof Button>) => {
  const { setEditorContext, activeMediaTab } = useEditorContext();

  return (
    <Button
      {...props}
      onClick={() => {
        setEditorContext({
          activeMediaTab:
            activeMediaTab === EDITOR_MEDIA_TAB.Embed
              ? null
              : EDITOR_MEDIA_TAB.Embed,
        });
      }}
    >
      <LuMonitorPlay className="text-lg" />
    </Button>
  );
};
